export const GPO_SUBTABS = [
  { label: 'Led by GPO', value: 'gpo' },
  {
    label: 'Led by Community',
    value: 'community'
  }
]
